var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo } from 'react';
import { getAccountId, getBalance, isExternal, isIneligibleExternal, isInvest, } from '@ally/transfer-account-utils';
import AccountSelect from '../AccountSelect';
import AccountTile from '../AccountTile';
function getBankName(account) {
    if (isInvest(account))
        return undefined;
    return account.domainDetails.bankName;
}
function getGroup(account) {
    if (isInvest(account))
        return 'invest';
    if (isExternal(account))
        return 'external';
    if (account.domainDetails.retirementIndicator)
        return 'ira';
    return 'internal';
}
export function mapAccount(account) {
    var accountNumberPvtEncrypt = account.accountNumberPvtEncrypt, accountStatus = account.accountStatus, accountType = account.accountType, nickname = account.nickname;
    return {
        accountId: getAccountId(account),
        accountNumber: accountNumberPvtEncrypt,
        balance: getBalance(account),
        bankName: getBankName(account),
        group: getGroup(account),
        isIneligible: isIneligibleExternal(account),
        nickname: nickname !== null ? nickname : undefined,
        status: accountStatus,
        type: accountType,
    };
}
export var mapAccounts = function (accounts) {
    return accounts.map(mapAccount);
};
export var TransferAccountSelect = forwardRef(function (_a, ref) {
    var accounts = _a.accounts, rest = __rest(_a, ["accounts"]);
    var mappedAccounts = useMemo(function () { return mapAccounts(accounts); }, [
        accounts,
    ]);
    return React.createElement(AccountSelect, __assign({ accounts: mappedAccounts, ref: ref }, rest));
});
export var TransferAccountTile = function (_a) {
    var id = _a.id, account = _a.account;
    var mappedAccount = useMemo(function () { return mapAccount(account); }, [account]);
    return React.createElement(AccountTile, { id: id, account: mappedAccount });
};
//# sourceMappingURL=TransferAccount.js.map